import { MouseEvent } from 'react';

import { RouteDictionary } from '../utils';
import { useNavigateByName } from './useNavigateByName';

const INTERACTIVE_SELECTOR = 'a, button, input, textarea, select, label, [role="button"]';

export const useProjectRowClick = (uuid: string, onClick?: () => void) => {
  const navigate = useNavigateByName();

  return (event: MouseEvent<HTMLElement>) => {
    const target = event.target as Element;

    if (target.closest && target.closest(INTERACTIVE_SELECTOR)) return;
    if (window.getSelection()?.toString()) return;

    onClick?.();
    navigate(RouteDictionary.DETAILED_PROJECT, { uuid });
  };
};
